import React from 'react'
import imgFill from 'assets/img/ic-road-fill.png'
import imgLine from 'assets/img/ic-road.png'
import BaseIcon from './BaseIcon'
import imgFillCM from 'assets/img/ic-road-fill-cm.png'
import imgLineCM from 'assets/img/ic-road-cm.png'

type Props = {
  active?: boolean
  isCM?: boolean
}

const RoadIcon = (props: Props) => {
  const { active = false, isCM = false } = props
  const activeIcon = isCM ? imgFillCM : imgFill
  const inactiveIcon = isCM ? imgLineCM : imgLine
  return (
    <BaseIcon
      active={active}
      activeIcon={activeIcon}
      inactiveIcon={inactiveIcon}
    />
  )
}

export default RoadIcon
